import React, { useState, useEffect } from 'react';
import { Pagination } from '@mui/material';
import { useGrade } from '../../pages/gradingModel/hooks';

export const GradingModelPagination = () => {
    const { loadGrades, pagination } = useGrade();
    const { pageNumber: pageNo, pageSize, totalPages } = pagination;

    const [page, setPage] = useState(1);

    const handlePageChange = (event, value) => {
        loadGrades({
            pageNo: value - 1, // backend pagination is 0-based
        });
        // setPage(value);
        // onPageChange(value);
    };

    useEffect(() => {
        if (!pageNo) return setPage(1);
        setPage(pageNo + 1);
    }, [pageNo])

    return (
        <div style={styles.paginationContainer}>
            <Pagination
                count={(totalPages || 1)}
                page={page}
                onChange={handlePageChange}
                color="primary"
            />
        </div>
    );
};


const styles = {
    paginationContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '3rem'
    }
}